'use es6';

import { Fragment, useEffect, useMemo } from 'react';
import { debounce } from 'underscore';
import { connect } from 'react-redux';
import I18n from 'I18n';
import { setSearchQuery as setSearchQueryAction } from 'FormsUI/actions/Properties';
import { getSearchQuery } from 'FormsUI/selectors/Properties';
import { getActiveTab } from 'FormsUI/selectors/PropertyNavigationTabs';
import { searchProperties as searchPropertiesAction, clearSearchProperties as clearSearchPropertiesAction } from 'FormsUI/actions/CustomObjects';
import { updatePropertyNavigationTab } from 'FormsUI/actions/PropertyNavigationTabs';
import { useTheme } from 'foundations-theming/utils';
import { ADD_NEW_PANEL, EXISTING_PANEL } from 'FormsUI/constants/PropertyNavigationTabs';
import EditorFeedbackSurvey from 'FormsUI/components/editor/EditorFeedbackSurvey';
import PropertiesSearchInput from 'FormsUI/components/editor/form/properties/PropertiesSearchInput';
import PropertyNavigationTabs from 'FormsUI/components/editor/leftPanel/navigation/PropertyNavigationTabs';
import useFeedbackSurvey from 'FormsUI/components/hooks/feedback/useFeedbackSurvey';
import ExistingPropertiesContainer from 'FormsUI/containers/editor/leftPanel/ExistingProperties';
import NewPropertiesContainer from 'FormsUI/containers/editor/leftPanel/NewProperties';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const langKey = suffix => `editor.form.properties.${suffix}`;

// eslint-disable-next-line no-control-regex
const nonAsciiRegex = /[^\x00-\x7F]/gm;
const PropertiesContainer = ({
  searchQuery = '',
  searchProperties = () => {},
  clearSearchProperties = () => {},
  setSearchQuery = () => {},
  activeTab,
  setActiveTab,
  step
}) => {
  const theme = useTheme();
  const {
    shouldDisplaySurvey,
    feedbackSurveyId
  } = useFeedbackSurvey(step);
  const debounceSearchProperties = useMemo(() => debounce(val => {
    searchProperties(val);
  }, 750), [searchProperties]);
  useEffect(() => () => setActiveTab(EXISTING_PANEL), [setActiveTab]);
  useEffect(() => {
    if (nonAsciiRegex.test(searchQuery) || searchQuery.length > 2) {
      debounceSearchProperties(searchQuery);
    } else {
      clearSearchProperties();
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [searchQuery]);

  // render
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "properties-container",
    "data-commenting-scroll-container": true,
    "data-onboarding": "properties-container"
    /* @bend-expect trellis-tokenized */,
    style: {
      height: '100%',
      overflowY: 'auto',
      zIndex: 1,
      borderRight: `${theme.space['25']} solid ${theme.color['border-core-default']}`
    },
    children: [/*#__PURE__*/_jsx(PropertyNavigationTabs, {
      onTabChange: setActiveTab,
      selectedTab: activeTab
    }), activeTab === EXISTING_PANEL ? /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(View, {
        padding: "600",
        paddingBlockEnd: "200",
        children: /*#__PURE__*/_jsx(PropertiesSearchInput, {
          searchQuery: searchQuery,
          handleQueryChange: setSearchQuery,
          placeholder: I18n.text(langKey('searchPlaceholder'))
        })
      }), /*#__PURE__*/_jsx(ExistingPropertiesContainer, {
        setActiveTab: () => setActiveTab(ADD_NEW_PANEL),
        activeTab: activeTab
      })]
    }) : /*#__PURE__*/_jsx(NewPropertiesContainer, {}), shouldDisplaySurvey && /*#__PURE__*/_jsx(EditorFeedbackSurvey, {
      feedbackId: feedbackSurveyId
    })]
  });
};
const mapStateToProps = state => ({
  searchQuery: getSearchQuery(state),
  activeTab: getActiveTab(state)
});
const mapDispatchToProps = {
  setSearchQuery: setSearchQueryAction,
  setActiveTab: updatePropertyNavigationTab,
  searchProperties: searchPropertiesAction,
  clearSearchProperties: clearSearchPropertiesAction
};
export default connect(mapStateToProps, mapDispatchToProps)(PropertiesContainer);